export const APP_PAGES_DATA = '[APP] APP_PAGES_DATA';
export const APP_START_FRONTEND = '[APP] APP_START_FRONTEND';
export const APP_SET_METADATA = '[APP] APP_SET_METADATA';
export const APP_SET_NAVIGATION = '[APP] APP_SET_NAVIGATION';
export const APP_DATA = '[APP] APP_DATA';
export const APP_PREVIEW_MODE = '[APP] APP_PREVIEW_MODE';

export const startFrontend = (data) => ({
  type: APP_START_FRONTEND,
  payload: data,
});

export const setAppData = (data) => ({
  type: APP_DATA,
  payload: data,
});

export const setPagesData = (data) => ({
  type: APP_PAGES_DATA,
  payload: data,
});

export const setAppPreviewMode = (data) => ({
  type: APP_PREVIEW_MODE,
  payload: data,
});
